import { __assign, __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
import Typography from '../Typography';
var CountWrapper = styled(Typography).attrs({
    type: 'caption',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", "px;\n  text-align: right;\n  flex: 1;\n  color: ", ";\n"], ["\n  margin-top: ", "px;\n  text-align: right;\n  flex: 1;\n  color: ",
    ";\n"])), function (props) { return props.theme.spacing.unit; }, function (props) {
    return props.error
        ? props.theme.palette.error[500]
        : props.theme.palette.text.secondary;
});
/**
 * 计数组件
 *
 * @ReactComponent
 */
function Count(props) {
    return (React.createElement(CountWrapper, __assign({}, props),
        props.number,
        "/",
        props.count));
}
export default Count;
var templateObject_1;
//# sourceMappingURL=Count.js.map